import { createRoot } from 'react-dom/client';
import { AuthProvider } from './auth/AuthProvider';
import { ThemeContext, useThemeState } from './hooks/useTheme';
import { App } from './App';
import { ResponsivePreview, shouldMountResponsivePreview } from './dev/responsive-preview';
import './globals.css';

/** Root wrapper that provides theme and auth contexts */
function Root(): React.JSX.Element {
  const theme = useThemeState();
  const preview = shouldMountResponsivePreview();

  return (
    <ThemeContext.Provider value={theme}>
      {preview ? (
        <ResponsivePreview />
      ) : (
        <AuthProvider>
          <App />
        </AuthProvider>
      )}
    </ThemeContext.Provider>
  );
}

createRoot(document.getElementById('root')!).render(<Root />);
